// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=1433-21737
// Component: addButton — outlined pill button with plus icon

export default function AddButton({ label, onClick, tabIndex, disabled }) {
  return (
    <button
      type="button"
      onClick={onClick}
      tabIndex={tabIndex}
      disabled={disabled}
      className="inline-flex items-center gap-3 px-3 py-2 rounded-button border-[1.5px] border-solid border-on-surface text-[15px] font-medium leading-5 text-on-surface whitespace-nowrap transition-colors duration-200 hover:bg-black/[0.04] focus-visible:bg-black/[0.12] disabled:opacity-[0.38] disabled:pointer-events-none"
    >
      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden="true" className="shrink-0">
        <path d="M5.5 1V10M1 5.5H10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
      {label}
    </button>
  )
}
